import React, {useState} from 'react';

import {Button, InputNumber, PopoverButton} from '@kit';

import {useCharacter} from '../character-context';
import {levelForExperience, nextLevelExperience} from '../model/experience';
import {withJournalEntry} from '../model/journal';

import css from './sheet.module.css';

/** уровень и опыт персонажа; по нажатию опыт можно добавить или задать */
export const ExperienceButton: React.FC = () => {
	const {state, character, update} = useCharacter();
	const [amount, setAmount] = useState<number | null>(null);
	const experience = state.experience || 0;
	const next = nextLevelExperience(character.level);
	const canLevelUp = levelForExperience(experience) > character.level;

	const setExperience = (value: number, title: string, total: number) => {
		const updated = Math.max(0, value);
		update((current) => ({
			experience: updated,
			...withJournalEntry(current, {kind: 'experience', title, total, details: `всего ${updated}`}),
		}));
		setAmount(null);
	};

	return (
		<PopoverButton
			size="small"
			appearance="subtle"
			className={css.experienceButton}
			popover={
				<div className={css.experiencePopover}>
					<InputNumber min={0} placeholder="0" label="Опыт" value={amount} onChange={setAmount} autoFocus />
					<div className={css.experienceButtons}>
						<Button
							appearance="primary"
							disabled={!amount}
							onClick={() => setExperience(experience + (amount || 0), 'Получен опыт', amount || 0)}
						>
							Добавить
						</Button>
						<Button
							disabled={amount == null}
							onClick={() => setExperience(amount || 0, 'Опыт задан', amount || 0)}
						>
							Задать
						</Button>
					</div>
				</div>
			}
		>
			<span>{character.level}-й уровень</span>
			<span className={canLevelUp ? css.experienceReady : undefined}>
				{experience.toLocaleString('ru')}
				{next !== undefined && ` / ${next.toLocaleString('ru')}`} опыта
			</span>
		</PopoverButton>
	);
};
